import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { FiArchive, FiRotateCcw } from 'react-icons/fi';

import axios from '../../../axios';
import * as url from '../../../utils/url';
import { toastContainer } from '../../../utils/toast';
import { withHashtagPrefix } from '../../../utils/hashtagPrefix';

// Flat list, one-click restore per row — no checkboxes/bulk action (matches the design).
const RecoverDeletedHashtagsModal = ({ isOpen, onClose, deletedHashtags, prefix, loading, hasMore, onLoadMore, onRestored }) => {
    const [restoringId, setRestoringId] = useState(null);

    const handleRestore = (item) => {
        if (restoringId) return;
        setRestoringId(item.id);
        axios.patch(url.textifyUpdateGroupStatus(item._id), { status: 'active' })
            .then(() => {
                // Also clears any standing collision error — toastContainer
                // dismisses the previous toast before showing this one.
                toastContainer('Hashtag restored.', 'success');
                onRestored(item.id);
            })
            .catch((err) => {
                const errMsg = (err.response && err.response.data && err.response.data.message) || (err.response && err.response.data && err.response.data.error) || 'Failed to restore hashtag.';
                toastContainer(errMsg, 'error');
            })
            .finally(() => setRestoringId(null));
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered className="bwai-modal recover-deleted-modal">
            <ModalHeader className="bwai_modal_header" toggle={onClose}>
                <span className="bwai_title_block">
                    <span className="bwai_title_text">
                        <FiArchive size={18} /> Recover Deleted Hashtags
                    </span>
                    <span className="bwai_title_sub">
                        Restore a deleted hashtag to bring it back along with its conversations.
                    </span>
                </span>
            </ModalHeader>
            <ModalBody>
                {deletedHashtags.length === 0 ? (
                    <div className="recover-empty">
                        Nothing to recover — deleted hashtags will appear here.
                    </div>
                ) : (
                    <div className="recover-list">
                        {deletedHashtags.map((item) => (
                            <div key={item.id} className="recover-row">
                                <div className="status-dot status-inactive" />
                                <div className="recover-row-name">#{withHashtagPrefix(item.name, prefix)}</div>
                                <div className="recover-row-count">
                                    {item.recipientCount} {item.recipientCount === 1 ? 'recipient' : 'recipients'}
                                </div>
                                <button
                                    type="button"
                                    className="recover-restore-btn"
                                    disabled={restoringId === item.id}
                                    onClick={() => handleRestore(item)}
                                >
                                    <FiRotateCcw size={13} /> {restoringId === item.id ? 'Restoring...' : 'Restore'}
                                </button>
                            </div>
                        ))}
                        {hasMore && (
                            <div className="recover-load-more-row">
                                <button type="button" className="recover-load-more-btn" disabled={loading} onClick={onLoadMore}>
                                    {loading ? 'Loading...' : 'Load more'}
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
};

export default RecoverDeletedHashtagsModal;
